import React from "react";
import {List} from "../modules/UserManagment";

export function UsersListPage() {
  return (
    <List />
  );
}
